export const DEFAULT_BUSINESS_CASE_TEST_DRIVE_SOON_HOURS = 24;
